module.exports = __webpack_public_path__ + "img/icon1024.ab9d93c3.png";